import { apiClient, Auth, PaginationSearchParams } from '@/shared/api'

import { THostPayComplete } from '../model/schema'

const DEFAULT_SIZE = 20

export type HostPayCompleteSearchParams = PaginationSearchParams & {
  onlySummary?: boolean
  rid?: string
  fromSettlementDate: string
  toSettlementDate: string
}

export const getHostPayComplete = async (
  params: HostPayCompleteSearchParams,
) => {
  const { data } = await apiClient.get<THostPayComplete>({
    endpoint: `/settlements/complete`,
    auth: Auth.REQUIRED,
    queryParams: {
      ...params,
      size: params.size ?? DEFAULT_SIZE,
    },
  })

  return data
}
